/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import UpgradeIcon from "@mui/icons-material/Upgrade";
import { PlanId } from "components/common/boundary/PlanId";
import { useTenantTranslation } from "hooks/formatters";
import { useIsDeployablePeriod } from "hooks/periodIndex.tsx";
import { useDeployPrefetch } from "hooks/useDeployPrefetch";
import { useDeployProcess } from "hooks/useDeployProcess";
import { PreFetchButton, PreFetchButtonConfig } from "../preFetchButton";
import { DeployModal } from "./deployModal";
import { mapLoadedUnpack } from "models/loaded";
import { useSearch } from "contexts/search/SearchContextProvider";
import { useIsBehindFeatureFlag } from "hooks/useFeatureFlag";
import { isPurchasingSearchType } from "src/utils/isPurchasingSearchType";

interface Props {
  planId: PlanId;
}

export const DeployButton = ({ planId }: Props) => {
  const { t } = useTenantTranslation();
  const isDeployablePeriod = useIsDeployablePeriod();
  const deployProcess = useDeployProcess();
  const purchasingPlanDeploy = useIsBehindFeatureFlag("purchasing_plan_deploy");

  const shouldPrefetch =
    deployProcess === "edit_sync_and_sms" || deployProcess === "message";
  const deployData = useDeployPrefetch(planId, shouldPrefetch);

  const searchType = mapLoadedUnpack(
    useSearch().parameters.server,
    ({ search_type }) => search_type
  );

  const shouldDisable =
    (!isDeployablePeriod && (!shouldPrefetch || !deployData.isLoading)) ||
    (searchType === null && searchType === undefined) ||
    (isPurchasingSearchType(searchType) && !purchasingPlanDeploy);

  const config: PreFetchButtonConfig = {
    label: t("deploy"),
    icon: <UpgradeIcon />,
    disabledTooltip: shouldDisable ? t("deployMixesOnly") : undefined,
    disabled: shouldDisable,
    isLoading: shouldPrefetch && deployData.isLoading,
    isSuccess: !shouldPrefetch || deployData.isSuccess,
    modalComponent: DeployModal,
    searchType,
  };

  return <PreFetchButton planId={planId} config={config} />;
};
